import { Tabs, Tab, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

export const NavBarRelatoriosFiscal = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
      <Tabs
        value={location.pathname}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="NFE" value="/relatoriosfiscal/rnfe" />
        <Tab label="NFC-E" value="/relatoriosfiscal/rnfce" />
        <Tab label="Produtos" value="/relatoriosfiscal/rprodutos" />

      </Tabs>
    </Box>
  );
};